module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_6005.be1ce75e.png";